export default function /* @ngInject */ stripeValidateCardNumber($q, stripeLoadSdk) {
    // Warn about incorrect card numbers before bothering the Stripe API.
    // https://stripe.com/docs/stripe.js?#card-validateCardNumber
    // https://stripe.com/docs/testing#cards
    function link(scope, element, attrs, ngModel) {
        stripeLoadSdk().then((Stripe) => {
            ngModel.$validators.card_number = function(value) {
                return Stripe.card.validateCardNumber(value || '');
            };
        });
    }
    return {
        require: 'ngModel',
        link: link
    };
}



// WEBPACK FOOTER //
// ./stripe/validators/stripe-validate-card-number.js